import apiClient from './apiClient';



export const getChatHistory = async () => {
  try {
    const response = await apiClient.get('/chat-sessions');
    return response.data;
  } catch (error) {
    console.error('Error fetching history:', error);
    throw error;
  }
};

export const getConversationFromHistory = async (thread_id) => {
  try {
    const response = await apiClient.get(`/chat-history/${thread_id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching conversation:', error);
    throw error;
  }
};

export const deleteChatSession = async (thread_id) => {
  try {
    const response = await apiClient.delete(`/chat-session/delete/${thread_id}`);
    return response.data; // Or you can return response.status === 204 for successful deletion
  } catch (error) {
    console.error(`Error deleting chat session with ID ${thread_id}:`, error);
    throw error;
  }
};

export const renameChatSession = async (params) => {
  try {
    const response = await apiClient.put(`/chat-session/rename`, params);
    return response.data; // Or you can return response.status === 204 for successful deletion
  } catch (error) {
    console.error(`Error renaming chat session with ID ${thread_id}:`, error);
    throw error;
  }
};
